export default __webpack_public_path__ + "static/media/longchamp9.cab1f319.jpg";